module.exports = __webpack_public_path__ + "img/mcarnev2.7ad27c6c.gif";